// extracted by mini-css-extract-plugin
export default {"root":"Loader_root-_Yq","loader":"Loader_loader-T80","secondary":"Loader_secondary-V8I"};